import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const fmtMoney = (v) => `$${(v ?? 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmtDate = (iso) => iso ? new Date(iso).toLocaleString('es-MX') : '—';

export const HistoryDetailDialog = ({ open, onOpenChange, kind, record }) => {
  if (!record) return null;

  const renderItems = (items) => (
    <div className="border rounded">
      <table className="w-full text-xs">
        <thead className="bg-slate-50 text-[10px] uppercase">
          <tr>
            <th className="px-2 py-1 text-left">Producto</th>
            <th className="px-2 py-1 text-right">Cantidad</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {(items || []).map((it, i) => (
            <tr key={i}>
              <td className="px-2 py-1">{it.product_name || it.name || '—'}</td>
              <td className="px-2 py-1 text-right font-semibold">{it.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderField = (label, value) => (
    <div className="grid grid-cols-3 gap-2 py-1 border-b last:border-0">
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className="col-span-2 text-sm">{value || '—'}</div>
    </div>
  );

  const titleByKind = {
    purchase: '🛒 Detalle de Compra',
    exit: '📤 Detalle de Salida',
    approval: '🔔 Detalle de Aprobación',
    shipment: '🚚 Detalle de Envío'
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{titleByKind[kind] || 'Detalle'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {kind === 'purchase' && (
            <>
              {renderField('Folio', <code className="text-xs">{record.folio}</code>)}
              {renderField('Fecha', fmtDate(record.created_at))}
              {renderField('Creado por', record.created_by_name)}
              {renderField('Proveedor', record.supplier_name)}
              {renderField('Notas', record.notes)}
              {renderField('Total piezas', <strong>{record.total_qty}</strong>)}
              <div>
                <p className="text-xs text-muted-foreground mb-1">Items:</p>
                {renderItems(record.items)}
              </div>
            </>
          )}
          {kind === 'exit' && (
            <>
              {renderField('Folio', <code className="text-xs">{record.folio}</code>)}
              {renderField('Fecha', fmtDate(record.created_at))}
              {renderField('Estado', record.status)}
              {renderField('Creado por', record.created_by_name)}
              {renderField('Motivo', record.reason)}
              {renderField('Aprobado en', fmtDate(record.approved_at))}
              {renderField('Total piezas', <strong>{record.total_qty}</strong>)}
              <div>
                <p className="text-xs text-muted-foreground mb-1">Items:</p>
                {renderItems(record.items)}
              </div>
            </>
          )}
          {kind === 'approval' && (
            <>
              {renderField('Tipo', record.type)}
              {renderField('Estado', record.status)}
              {renderField('Solicitado', fmtDate(record.requested_at))}
              {renderField('Por', record.requested_by_user_name)}
              {renderField('Resuelto', fmtDate(record.resolved_at))}
              {renderField('Vía', record.resolved_by_role)}
              <div>
                <p className="text-xs text-muted-foreground mb-1">Datos:</p>
                <pre className="bg-slate-50 border rounded p-2 text-[10px] overflow-x-auto">
                  {JSON.stringify(record.payload, null, 2)}
                </pre>
              </div>
            </>
          )}
          {kind === 'shipment' && (
            <>
              {renderField('Folio', <code className="text-xs">{record.folio}</code>)}
              {renderField('Fecha', fmtDate(record.created_at))}
              {renderField('Estado', record.status)}
              {renderField('Cliente', record.client_name)}
              {renderField('Teléfono', record.client_phone)}
              {renderField('Dirección', record.shipping_address)}
              {renderField('Notas', record.notes)}
              {renderField('Total productos', fmtMoney(record.items_total))}
              {renderField('Costo envío', fmtMoney(record.shipping_cost))}
              {renderField('Entregador se queda con envío', record.deliverer_keeps_shipping ? 'Sí' : 'No')}
              <div>
                <p className="text-xs text-muted-foreground mb-1">Items:</p>
                {renderItems(record.items)}
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
